import React, {Component} from 'react';
import {Button, Col, DropdownButton, Image, MenuItem, OverlayTrigger, Row} from 'react-bootstrap';
// import {SketchPicker} from 'react-color';
import reactCSS from 'reactcss';
import ManateeDropdown from '../../components/ManateeDropdown';
import tooltips from '../../components/Tooltips';
import Colour_Picker from '../../components/Colour_Picker';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        &#x25bc;
    </a>
));

class BackgroundOptionsPanel extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            displayColorPicker: false,
            animationDuration: 5,
            bulk_edit_label_temp: "",
            bulk_edit_open: false
        }
    }

    
    handleLabelChange = (e) => {
        this.setState({bulk_edit_label_temp: e.target.value});
    }

    handleSpaceBar = (e) => {
        if(e.key == " "){
            e.preventDefault();
            e.stopPropagation();
            this.setState({bulk_edit_label_temp: this.state.bulk_edit_label_temp + " "});
        }
    }

    get_current_label = () => {
        if(this.props.design_selection && this.props.design_selection.class_type == "background" && window.design_editor.active_page.background.user_labels && window.design_editor.active_page.background.user_labels["image"]){
            var label_id = window.design_editor.active_page.background.user_labels["image"];
            var label_find = window.design_editor.design.bulk_edit_data.labels.find(o => {return o.id == label_id})
            if(label_find){
                return label_find.text
            }
        }
        return "";
    }

    bulk_edit_on_click = async () => {
        if(this.get_current_label() == "" && this.state.bulk_edit_label_temp != ""){
            if(this.props.design_selection && this.props.design_selection.class_type == "background"){
                var sel = window.design_editor.active_page.background;
                var new_label_id = window.utils.uuidv4()
                window.design_editor.design.bulk_edit_data.labels.push({
                    id: new_label_id, text: this.state.bulk_edit_label_temp, assigned: [this.props.design_selection.id], selected: true, type: 'image'
                });
                
                this.props.design_selection.user_labels["image"] = new_label_id;
                window.design_editor.addUndoChange()
            }
            this.setState({});
        }

        await this.props.switch_nav_tab("");
        await this.props.switch_nav_tab("bulk_edit");
    }

    bulk_edit_toggle = (isOpen, e) => {
        if(e.target.type != 'text'){
            this.setState({bulk_edit_open:isOpen})
        }
    }

    componentDidMount() {
        if(window.design_editor && window.design_editor.active_page) {
            this.setState({
                animationDuration : window.design_editor.active_page.animation_duration
            })
        }
        this.setState({bulk_edit_label_temp:""});
    }

    componentWillUnmount() {
        
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
      };
    
    handleClose = () => {
        this.setState({ displayColorPicker: false })
      };

    get_color_picker = () => {
        const styles = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px',
                background: this.props.design_editor?(this.props.design_editor.active_page.background.image_exists()?('#ffffff'):this.props.design_editor.active_page.background.background_color):'#999999'
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
          });

        const Dropdown_trigger = ({ toggle_dropdown }) => (
            <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_enhance.svg'} />
            </Button>
        )

        const Dropdown_dropper = () => (
            <ul className="toolbar-dropdown">
                <li className="toolbar-dropdown-item" onClick={(e) => {this.props.switch_nav_tab('filters')}}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_filter.svg'} />
                    <span className="toolbar-dropdown-text">Filter                               </span>
                </li>
                <li className="toolbar-dropdown-item" onClick={this.props.adjustmentPanelOnclick}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_brightnesscontrast.svg'} />
                    <span className="toolbar-dropdown-text">Adjustment</span>
                </li>
                {/*<li className="toolbar-dropdown-item" onClick={this.props.backgroundRemovalPanelOnclick}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_bg_remove.svg'} />
                    <span className="toolbar-dropdown-text">Remove Background</span>
                </li>*/}
                {/*this.props.design_editor && this.props.design_editor.active_page && this.props.design_editor.active_page.background.image_exists() && this.props.design_editor.active_page.background.sub_type == 'mockup'?(
                    <li className="toolbar-dropdown-item" onClick={this.props.mockupEditorPanelOnclick}>
                        <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/Mockup.svg'} />
                        <span className="toolbar-dropdown-text">Edit Mockup</span>
                    </li>
                ):''*/}
            </ul>
        )


        if(this.props.design_editor && this.props.design_editor.active_page && !this.props.design_editor.active_page.background.image_exists()){
            return (
                <div style={{marginRight:'5px'}}>
                    <div style={ styles.swatch } onClick={ this.handleClick }>
                    <div style={ styles.color } />
                    </div>
                    { this.state.displayColorPicker ? <div style={ styles.popover }>
                    <div style={ styles.cover } onClick={ this.handleClose }/>
                    <Colour_Picker 
                        presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} 
                        disableAlpha={true} 
                        color={this.props.design_editor?(this.props.design_editor.active_page.background.background_color):'#999999'} 
                        onChange={ (e) => {this.props.update_inputs_background(e,'color') }} 
                        user={this.props.user}
                    />
                    </div> : null }
                </div>
            )
        }else if(this.props.design_editor && this.props.design_editor.active_page && this.props.design_editor.active_page.background.image_exists()){
            return (
                <React.Fragment>
                    {this.props.design_editor.active_page.background_sub_type == 'mockup'?(
                        <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['edit_mockup']}>
                            <Button className="btn-toolbar" onClick={this.props.mockupEditorPanelOnclick} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/Mockup.svg'} />
                            </Button>
                        </OverlayTrigger>
                    ):''}
                    <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['photo_editor']}><div>
                        <ManateeDropdown 
                            Trigger={Dropdown_trigger}
                            Dropper={Dropdown_dropper}
                        />
                    </div></OverlayTrigger>
                </React.Fragment>

            )
        }else{
            return (<div></div>)
        }
    }

    Dropdown_trigger = ({ toggle_dropdown }) => (
        <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
            <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_vertically.svg'} />
        </Button>
    )

    Dropdown_dropper = () => (
        <ul className="toolbar-dropdown">
            <li className="toolbar-dropdown-item" onClick={(e) => {this.props.update_inputs_background(e,'flip_horizontal')}}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_horizontally.svg'} />
                <span className="toolbar-dropdown-text">Flip Horizontal</span>
            </li>
            <li className="toolbar-dropdown-item" onClick={(e) => {this.props.update_inputs_background(e,'flip_vertical')}}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_vertically.svg'} />
                <span className="toolbar-dropdown-text">Flip Vertical</span>
            </li>
        </ul>
    )

    AnimationTimerIcon = () => (
            <Button className="btn-toolbar"  style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                <i className="far fa-clock fa-lg" style={{marginRight: 5}}/>
                {window.design_editor.active_page.animation_duration + 's'}
            </Button>
    );

    isValidInput = (inp, min, max) => {
        if (inp === "") return true;
        let val = parseFloat(inp);
        return (!isNaN(val) && val >= min && val <= max);
    };

    animationDurationOnChange = (e) => {
        const min = 1;
        const max = 30.0;
        if (this.isValidInput(e.target.value, min, max)) {
            console.log("Setting input -> ", e.target.value);
            this.setState(
                {animationDuration: e.target.value}
            );
            this.setAnimationDuration(e.target.value)
        }
    };

    setAnimationDuration = (duration) => {
        window.design_editor.active_page.animation_duration = duration;
    };

    
    render() {
        return (
            <Row className="d-flex align-items-center" style={{padding: 5, backgroundColor: '#F1F2F3', zIndex :1010}}>
                <Col xs={6} style={{'display':'flex','flexFlow':'row',zIndex:"10000"}}>
                    {this.get_color_picker()}
                    {window.design_editor.active_page.background.image_exists() && (
                        <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['crop']}>
                            <Button className="btn-toolbar" onClick={this.props.enter_crop_mode} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/crop_temp.svg'} />
                            </Button>
                        </OverlayTrigger>
                        // <Button className="btn-toolbar" style={{'marginRight': '5px'}} onClick={this.props.enter_crop_mode}>Crop</Button>
                    )}
                    {window.design_editor.active_page.background.image_exists() && (
                        <React.Fragment>
                            <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['flip']}><div>
                                <ManateeDropdown 
                                    Trigger={this.Dropdown_trigger}
                                    Dropper={this.Dropdown_dropper}
                                />
                            </div></OverlayTrigger>
                            <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['bg_removal']}>
                                <Button className="btn-toolbar" onClick={this.props.toggle_background_removal} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                    <Image style={{ height: 20 }} src={window.design_editor.active_page.background.bgremoval.enabled?global.config.static_file_server_path + 'uploads/icons/image_bg_remove_cancel.svg':global.config.static_file_server_path + 'uploads/icons/image_bg_remove.svg'} />
                                </Button>
                            </OverlayTrigger>
                        </React.Fragment>
                        // <DropdownButton id="lolll" key={1} className="btn-toolbar" style={{'marginRight': '5px'}} title="Flip">
                        //     <MenuItem eventKey={1} onClick={(e) => {this.props.update_inputs_background(e,'flip_horizontal')}}>Flip Horizontal</MenuItem>
                        //     <MenuItem eventKey={2} onClick={(e) => {this.props.update_inputs_background(e,'flip_vertical')}}>Flip Vertical</MenuItem>
                        // </DropdownButton>
                    )}
                    {global.config.application_env != "" && (<OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['animate']}>
                        <Button className="btn-toolbar" onClick={() => this.props.animateOnClick("page")} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                            <Image style={{ height: 20 }} src={null} />
                            Animate
                        </Button>
                    </OverlayTrigger>)}
                    {window.design_editor.design.isAnimated() ?
                        <DropdownButton
                            pullLeft={true}
                            className="btn-toolbar anim-timer-btn"
                            style={{'marginRight': '5px'}}
                            title={<this.AnimationTimerIcon/>}
                        >
                            <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px",width:'300px'}} draggable="false">
                                <div style={{display:'flex',flexFlow:'row'}}>
                                    <p style={{margin:'auto',display:'block', marginRight: 5, width: '20%'}}>Timing</p>
                                    <div style={{width: '70%', marginRight: 5}}>
                                        <input type="range" className="adjustment-slider" name="contrast" min="0.1" max="30"
                                               value={this.state.animationDuration}
                                               onChange={(e) => this.animationDurationOnChange(e)}/>
                                    </div>
                                    <div style={{width: '10%'}}>
                                        <input type="text" className="adjustment-input-text" name="contrast"
                                               onChange={(e) => this.animationDurationOnChange(e)}
                                               value={this.state.animationDuration}/>
                                    </div>
                                </div>
                            </MenuItem>
                        </DropdownButton>
                        : null}
                    <DropdownButton
                        pullLeft={true}
                        className="btn-toolbar" 
                        style={{'marginRight': '5px'}}                    
                        title="Bulk Label"
                        open={this.state.bulk_edit_open}
                        onToggle={this.bulk_edit_toggle}
                        >
                            <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px",width:'300px'}} draggable="false">
                                <Row>
                                    <Col xs={2}>
                                        <Image style={{ height: 30, float:"right"}} src={global.config.static_file_server_path + 'uploads/icons/Photos.svg'} />
                                    </Col>
                                    <Col xs={10} style={{paddingLeft:0, paddingRight:0}}>
                                        {/* <InputGroup style={{border: "1px solid grey",width:"100%"}}> */}
                                            {this.get_current_label()==""?(<input
                                                key={"create_new_label"}
                                                value={this.state.bulk_edit_label_temp}
                                                style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                placeholder={'Enter a label'}
                                                type="text"
                                                onKeyUp={(e) => this.handleSpaceBar(e)}
                                                onChange={(e) => this.handleLabelChange(e)}
                                            />):(<input
                                                key={"manage_labels"}
                                                style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                placeholder={'Enter a label'}
                                                value={this.get_current_label()}
                                                type="text"
                                                disabled={true}
                                                // onChange={(e) => handleChange(id, e)}
                                            />)}
                                        {/* </InputGroup> */}
                                    </Col>
                                </Row>
                            </MenuItem>
                            <MenuItem className="disable-hover-bg" style={{display:"flex",justifyContent:"center",paddingTop:"10px",paddingBottom:"10px"}} draggable="false">
                                <Button onClick={this.bulk_edit_on_click} className="btn btn-sm btn-block btn-orange" style={{textAlign: 'center'}}>{this.get_current_label()!=""?"Manage Labels":" OK "}</Button>
                            </MenuItem>
                    </DropdownButton>
                </Col>
                <Col xs={6} className="text-right" style={{'display':'inline'}}>
                    
                </Col>            
            </Row>
        );
    }
}

export default BackgroundOptionsPanel;